import { render, staticRenderFns } from "./ac-text-area.vue?vue&type=template&id=712b42cc&"
import script from "./ac-text-area.vue?vue&type=script&lang=js&"
export * from "./ac-text-area.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports